import { withStyles } from '@mui/styles';

import { FirmUserWallets } from './firmUserWallets';
import { muiStyles } from './styles';

export default withStyles(muiStyles)(FirmUserWallets);